<template>
  <v-layout v-if="flights && flights.length > 0" row wrap>

    <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar" v-bind:color="snackbarkColor"></snackbarcomp>
    <v-dialog v-model="dialogpickitem" persistent max-width="490">
      <v-card>
        <v-card-title class="headline primary white--text">
          {{ $t('Markup-Added-per-Person') }}
          <v-spacer></v-spacer>

        </v-card-title>
        <v-card-text>
          <v-text-field outline :label="$t('Markup-Added-per-Person')" v-model="ticketMarkup"
            @keyup.enter="selectFlight()">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialogpickitem = false">{{
            $t("Cancel")
          }}

          </v-btn>

          <v-btn color="primary" flat @click="selectTickets()">{{
            $t("Continue")
          }}
            <v-icon right>send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-flex xs12 sm6 md6>
      <v-btn color="error" @click="clearGidis">Gidişi Temizle</v-btn>
      <SelectFlight :flights="displayGidislerList" :step="1" :selectedFlight="gidisSelectedFlight"
        @clearFlight="clearGidis" @selectFlight="selectGidisFlight" :FlightType="'RT'" @toggle-loading="toggleLoading"
        @toggle-snackbar="toggleSnackbar" :currency="currency" />
    </v-flex>
    <v-flex xs12 sm6 md6>
      <v-btn color="error" @click="clearDonus">Dönüşü Temizle</v-btn>
      <SelectFlight :flights="displayDonuslerList" :step="2" :selectedFlight="donusSelectedFlight"
        @clearFlight="clearDonus" @selectFlight="selectDonusFlight" :FlightType="'RT'" @toggle-loading="toggleLoading"
        @toggle-snackbar="toggleSnackbar" :currency="currency" />
    </v-flex>
  </v-layout>
</template>
<script>
import SelectFlight from '../comp/SelectFlightNew.vue';
import logoo from "../../../../../../assets/control";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import Airports from "../../../ucak/airports.js";
export default {
  name: "DomesticRT",
  data() {
    return {
      gidisSelectedFlight: null,
      donusSelectedFlight: null,
      selectedGidisFareCode: "",
      selectedDonusFareCode: "",
      loadingvmodel: false,
      snackbar: false,
      text1: "",
      snackbarkColor: "error",
      allocated: Airports.allocateParams(),
      allocateItems: Airports.allocateItems(),
      dialogpickitem: false,
    };
  },
  props: {
    flights: {
      type: Array,
      required: true,
    },
    displayGidislerList: {
      type: Array,
      required: true,
    },
    displayDonuslerList: {
      type: Array,
      required: true,
    },
    ticketMarkup: {
      type: Number,
      required: true,
    },
    FlightType: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      default: 'TRY',
    },
  },
  components: {
    SelectFlight,
    loadingcomp,
    snackbarcomp,
  },
  computed: {
  },
  methods: {
    toggleLoading(val) {
      this.loadingvmodel = val;
    },
    toggleSnackbar(val, msg, color) {
      this.snackbar = val;
      this.text1 = msg;
      this.snackbarkColor = color;
    },
    clearGidis() {
      this.gidisSelectedFlight = null;
      this.selectedGidisFareCode = "";
    },
    clearDonus() {
      this.donusSelectedFlight = null;
      this.selectedDonusFareCode = "";
    },
    selectGidisFlight(flight, fare) {
      this.gidisSelectedFlight = flight;
      this.selectedGidisFareCode = fare;
      if(this.donusSelectedFlight && this.selectedDonusFareCode) {
        this.dialogpickitem = true;
      }
    },
    selectDonusFlight(flight, fare) {
      console.log("donus flight", flight, fare);
      this.donusSelectedFlight = flight;
      this.selectedDonusFareCode = fare;
      if(this.gidisSelectedFlight && this.selectedGidisFareCode) {
        this.dialogpickitem = true;
      }
    },
    getTicketFare(ticket) {
      if (ticket.TotalFare && Number(ticket.TotalFare) > 0) return Number(ticket.TotalFare);
      if (ticket.SelectableFares && ticket.SelectableFares.length > 0) {
        return Number(ticket.SelectableFares[0].TotalFare) || 0;
      }
      return 0;
    },
    async selectTickets() {
      console.log("gidis selected flight", this.gidisSelectedFlight);
      console.log("donus selected flight", this.donusSelectedFlight);
      if (this.gidisSelectedFlight && this.donusSelectedFlight) {
        var gidisCheck = await this.checkTurna(this.gidisSelectedFlight);
        var donusCheck = await this.checkTurna(this.donusSelectedFlight);
        if (!gidisCheck || !donusCheck) {
          return;
        }
        await this.prepareAllocateParams();
        window.localStorage.setItem("flightType", this.FlightType);
        window.localStorage.setItem(
          "allocateParams",
          JSON.stringify(this.allocated)
        );
        var url = "#/satis/ucus/islem/id?islem=new";
        window.open(url, "_self");

      } else {
        this.text1 = "Lütfen gidiş ve dönüş biletlerini seçiniz.";
        this.snackbar = true;
        this.snackbarkColor = "error";
      }
    },
    async checkTurna(ticket) {
      var isTurna =
        ticket &&
        ticket.FlightSegments &&
        ticket.FlightSegments.length > 0 &&
        ticket.FlightSegments[0] &&
        ticket.FlightSegments[0].Provider === "Turna";

      if (isTurna) {
        const hasTurna = await this.getProvidersTurna();

        if (!hasTurna) {
          this.text1 = "Bilet Kesim ve Rezervasyon İşlemi İçin Turna Acente Kodu Belirtilmeli";
          this.snackbar = true;
          return false;
        }
      }
      return true;
    },
    clearFlights() {
      this.gidisSelectedFlight = null;
      this.donusSelectedFlight = null;
      this.selectedGidisFareCode = "";
      this.selectedDonusFareCode = "";
    },
    async prepareAllocateParams() {
      this.allocated = Airports.allocateParams();
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      this.allocated.SessionHeader.SessionId = bookingParams.SessionId;
      this.allocated.SessionHeader.SessionToken = bookingParams.SessionToken;
      if (this.gidisSelectedFlight.FlightSegments.length > 1) {
        let allocateFirstParams = {
          ProductId: this.gidisSelectedFlight.FlightSegments[0].ProductId,
          FareCode: this.selectedGidisFareCode ? this.selectedGidisFareCode : "",
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0
        }
        this.allocated.AllocateItems.push(allocateFirstParams);
        let allocateLastParams = {
          ProductId:
            this.gidisSelectedFlight.FlightSegments[this.gidisSelectedFlight.FlightSegments.length - 1].ProductId,
          FareCode: this.selectedGidisFareCode ? this.selectedGidisFareCode : "",
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateLastParams);
      }
      else {
        this.allocateItems.ProductId = this.gidisSelectedFlight.Id;
        this.allocateItems.FareCode = this.selectedGidisFareCode ? this.selectedGidisFareCode : "";
        this.allocateItems.MarkupFare = this.ticketMarkup;
        this.allocated.AllocateItems.push(this.allocateItems);
      }
      if (this.donusSelectedFlight.FlightSegments.length > 1) {
        let allocateFirstParams = {
          ProductId: this.donusSelectedFlight.FlightSegments[0].ProductId,
          FareCode: this.selectedDonusFareCode ? this.selectedDonusFareCode : "",
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateFirstParams);

        let allocateLastParams = {
          ProductId:
            this.donusSelectedFlight.FlightSegments[this.donusSelectedFlight.FlightSegments.length - 1].ProductId,
          FareCode: this.selectedDonusFareCode ? this.selectedDonusFareCode : "",
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateLastParams);
      } else {
        let allocateLastParamsRT = {
          ProductId:
            this.donusSelectedFlight.Id,
          FareCode: this.selectedDonusFareCode ? this.selectedDonusFareCode : "",
          MarkupFare: this.ticketMarkup,
          SetServiceFare: 0,
        };
        this.allocated.AllocateItems.push(allocateLastParamsRT);
      }
    },
    async getProvidersTurna() {
      try {
        var bookingParams = JSON.parse(
          window.localStorage.getItem("bookingParams")
        );

        var params = {
          SessionHeader: {
            SessionId: bookingParams.SessionId,
            SessionToken: bookingParams.SessionToken
          }
        };

        const response = await this.$http.post(
          auth.BOOKING_API_URL + "Agency/GetCredential",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        );

        const rsp = response.body.Credentials;

        const turnaProvider = rsp.find(x =>
          x.ProviderType === "Air" &&
          x.Provider === "Turna" &&
          x.OfficeId &&
          x.OfficeId !== ""
        );

        return !!turnaProvider;

      } catch (error) {
        this.text1 = "GetCredential - Service Unavailable";
        this.loadingvmodel = false;
        this.snackbar = true;
        return false;
      }
    },

  }
};
</script>
